import { useShipStore } from '@/stores/shipStore.ts'
import * as THREE from "three";
import { MapETA } from '@/models/Map/MapETA.ts'
import { useMapStore } from '@/stores/mapStore.ts'

export class MapShipActionPaths {

    scene: THREE.Scene;
    actionLine: THREE.Line | null;
    mapETA: MapETA | null;
    shipStore: any;
    mapStore: any;
    xPos: number;
    yPos: number;

    constructor(scene: THREE.Scene) {
        this.scene = scene;
        this.actionLine = null;
        this.mapETA = null;
        this.shipStore = useShipStore();
        this.mapStore = useMapStore();
        this.xPos = 0;
        this.yPos = 0;
    }

    create(xPos: number, yPos: number) {
        this.xPos = xPos;
        this.yPos = yPos;
        const path = this.getFirstPathFromShips();
        if(path.length === 0) {
            return;
        }
        this.drawPath(path);
    }

    deleteLines() {
        if (this.mapETA) {
            this.mapETA.dispose();
            this.mapETA = null;
        }
        if (this.actionLine) {
            this.scene.remove(this.actionLine);
            this.actionLine.geometry.dispose();
            (this.actionLine.material as THREE.Material).dispose();
            this.actionLine = null;
        }
    }

    drawPath(path: any) {
        // Remove existing line before drawing a new one
        this.deleteLines();

        if (!path || path.length === 0) {
            return; // No path to draw
        }

        const material = new THREE.LineBasicMaterial({ color: 0x800080 });
        const points = [];
        points.push(new THREE.Vector3(this.xPos, this.yPos, 0.2));
        path.forEach((action: any) => {
            // Skip adding points for stationary/autonomous commands (repair, defend, wait)
            if (action.action !== 'repair' && action.action !== 'defend' && action.action !== 'wait') {
                points.push(new THREE.Vector3(action.targetX, action.targetY, 0.2));
            }
        });
        
        // Only create the line if we have at least 2 points
        if (points.length < 2) {
            return; // Not enough points to draw a line
        }
        
        const geometry = new THREE.BufferGeometry().setFromPoints(points);
        this.actionLine = new THREE.Line(geometry, material);
        this.scene.add(this.actionLine);

        this.mapETA = new MapETA(this.actionLine);
    }

    updateZoom(newZoom: number) {
        if (this.mapETA) {
            this.mapETA.updateZoom(newZoom);
        }
    }

    getFirstPathFromShips(): any {
        // Iterate ships directly without creating intermediate array
        for (const ship of this.shipStore.ships.values()) {
            if (ship.xPos == this.xPos && ship.yPos == this.yPos) {
                if (ship.actions && ship.actions.length > 0) {
                    this.mapStore.etaSpeed = ship.maxSpeed;
                    return ship.actions;
                }
            }
        }

        return []; // Return an empty array if no ship with actions is found
    }
}
